import styles from "../pendingContractors/AuditData.module.css";
import QuestionSection from "../contractorAudit/auditQuestions/QuestionSection";
import SectionHeader from "../../components/ui/labels/SectionHeader";
import useQuestions from "../../hooks/useAuditQuestions";
import DataLabel from "../../components/ui/labels/DataLabel";
import AuditQuestionCard from "../../components/ui/containers/AuditQuestionCard";
import ImagePreviewPrompt from "../../components/ui/prompts/ImagePreviewPrompt";
import { useState } from "react";

const AuditData = ({ questionData }) => {
  const { splicerQuestions } = useQuestions();
  const [preview, setPreview] = useState(null);

  const constructQuestion = (question) => {
    let photoCount = 0;
    return (
      <AuditQuestionCard
        questionGUID={question.QUESTION_GUID}
        inputGiven={true}
      >
        <p className={styles.auditQuestion}>{question.QUESTION}</p>
        <DataLabel title={"Response"} text={question.SELECTED_OPTION} />
        {question.TEXT_INPUT && (
          <DataLabel title={"Explanation"} text={question.TEXT_INPUT} />
        )}
        {question?.PHOTOS?.length > 0 && (
          <div className={styles.photosDiv}>
            {question.PHOTOS.map((photo) => (
              <img
                className={styles.photos}
                key={`${question.QUESTION_GUID}_${photoCount++}`}
                alt="questionPhoto"
                src={`data:image/png;base64, ${photo}`}
                onClick={() =>
                  setPreview({
                    base64Key: `${question.QUESTION_GUID}_${photoCount++}`,
                    base64Src: `data:image/png;base64, ${photo}`,
                  })
                }
              />
            ))}
          </div>
        )}
      </AuditQuestionCard>
    );
  };

  return (
    <>
      {questionData && (
        <div className={styles.card}>
          <SectionHeader text="Audit Questions" overrideFontSize={"24px"} />
          <QuestionSection title="Required PPE">
            {constructQuestion(
              questionData.find(
                (x) => x.QUESTION_GUID === splicerQuestions.requiredPPE
              )
            )}
          </QuestionSection>
          <QuestionSection title="Required WAP">
            {constructQuestion(
              questionData.find(
                (x) => x.QUESTION_GUID === splicerQuestions.requiredWAP
              )
            )}
          </QuestionSection>
          <QuestionSection title="Fiber Splicing">
            {constructQuestion(
              questionData.find(
                (x) => x.QUESTION_GUID === splicerQuestions.fiberSplicing
              )
            )}
          </QuestionSection>
          <QuestionSection title="Housekeeping">
            {constructQuestion(
              questionData.find(
                (x) => x.QUESTION_GUID === splicerQuestions.housekeeping
              )
            )}
          </QuestionSection>
        </div>
      )}
      <ImagePreviewPrompt
        preview={preview}
        deleteable={false}
        confirmHandler={() => setPreview(null)}
      />
    </>
  );
};

export default AuditData;
